"use client";

import { useState } from "react";
import { HERMES_SKILL_CATEGORIES, formatSkillLabel } from "@/lib/hermesSkills";

export default function SkillMarketplace({ categoryLabels }: { categoryLabels: readonly string[] }) {
  const [active, setActive] = useState(0);
  const activeSkills = HERMES_SKILL_CATEGORIES[active]?.skills ?? [];

  return (
    <div>
      <div className="flex flex-wrap justify-center gap-2" role="tablist">
        {categoryLabels.map((label, i) => (
          <button
            key={label}
            role="tab"
            aria-selected={active === i}
            onClick={() => setActive(i)}
            className={`rounded-full px-4 py-2.5 text-sm font-medium transition ${
              active === i
                ? "bg-[var(--af-accent)] text-black"
                : "border border-[var(--af-border)] text-[var(--af-muted)] hover:border-[var(--af-accent)] hover:text-[var(--af-text)]"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      <div
        className="af-fade-in mt-6 max-h-96 overflow-y-auto rounded-3xl border border-[var(--af-border)] bg-[var(--af-bg)] p-4 sm:p-6"
        style={{ boxShadow: "var(--af-shadow)" }}
      >
        <div className="flex flex-wrap gap-2">
          {activeSkills.map((slug) => (
            <span
              key={slug}
              className="rounded-full border border-[var(--af-border)] bg-[var(--af-bg-soft)] px-3.5 py-1.5 text-[13px] text-[var(--af-text)]"
            >
              {formatSkillLabel(slug)}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
